module.exports = __webpack_public_path__ + "static/media/web-mockup.73336633.png";